import React from 'react'
import '../css/spinner-new.css'

class LoadingSpinnerSmallNew extends React.Component {
  render() {
    return (
      <div className="sk-fading-circle-new" style={{backgroundColor:'#046eb5', borderRadius:'50%',height: '64px', width: '64px', margin: '0 15px 0 0', textAlign:"center"}}  >
        <div className="sk-circle1 sk-circle" />
        <div className="sk-circle2 sk-circle" />
        <div className="sk-circle3 sk-circle" />
        <div className="sk-circle4 sk-circle" />
        <div className="sk-circle5 sk-circle" />
        <div className="sk-circle6 sk-circle" />
        <div className="sk-circle7 sk-circle" />
        <div className="sk-circle8 sk-circle" />
        <div className="sk-circle9 sk-circle" />
        <div className="sk-circle10 sk-circle" />
        <div className="sk-circle11 sk-circle" />
        <div className="sk-circle12 sk-circle" />
      </div>
    )
  }
}

export default LoadingSpinnerSmallNew
